export default {
  "nav.events": "活动",
  "nav.gallery": "相册",
  "nav.contact": "联系我们",

  "hero.benefit": "3个厅 • 10位DJ • 1张全通票",
  "hero.getTickets": "立即购票",
  "hero.soldOut": "售罄",

  "land.saveDate": "记下这个日子",
  "land.upcomingA": "即将到来的",
  "land.upcomingB": "活动",
  "land.festival": "音乐节",
  "land.getTicketsArrow": "立即购票 →",

  "home.watchEyebrow": "回顾视频",
  "home.watchA": "回顾",
  "home.watchB": "Takeover",
  "home.stagesEyebrow": "一张票，三个世界",
  "home.stagesA": "探索",
  "home.stagesB": "3大舞台",
  "stage.seoul.name": "Seoul Floor",
  "stage.seoul.desc": "Powered by SeoulVibes",
  "stage.seoul.floor": "7楼",
  "stage.main.name": "Mainstream Floor",
  "stage.main.desc": "经典 DUPLEX 体验",
  "stage.main.floor": "6楼",
  "stage.saigon.name": "Saigon Floor",
  "stage.saigon.desc": "Powered by GANGSHII",
  "stage.saigon.floor": "5楼",
  "home.lineupEyebrow": "阵容",
  "home.whoA": "谁演出",
  "home.whoB": "— 什么时候？",
  "home.insideEyebrow": "从空中俯瞰",
  "home.insideA": "走进",
  "home.insideB": "Duplex",
  "home.ctaA": "准备好迎接",
  "home.ctaB": "Takeover了吗？",
  "home.buyTickets": "购买门票",

  "footer.tagline": "布拉格最大的亚洲音乐节体验。三个厅，一张票，难忘的夜晚。",
  "footer.quickLinks": "快速链接",
  "footer.faq": "常见问题",
  "footer.terms": "条款与条件",
  "footer.privacy": "隐私政策",
  "footer.refund": "退款政策",
  "footer.followUs": "关注我们",
  "footer.rights": "© 2026 ASIA TAKEOVER. 版权所有。",
  "footer.doorStaff": "入场工作人员",
  "footer.admin": "Admin",

  "cookies.title": "Cookies",
  "cookies.text": "我们使用必要的cookies来运行网站并处理您的订单。经您许可，我们还会使用分析和营销cookies（Meta Pixel）来衡量广告效果。您可以拒绝可选cookies，仍可正常购票。",
  "cookies.necessary": "必要（始终开启）",
  "cookies.analytics": "分析",
  "cookies.marketing": "营销 / Meta Pixel",
  "cookies.acceptAll": "全部接受",
  "cookies.customize": "自定义",
  "cookies.save": "保存选择",
  "cookies.reject": "拒绝可选",

  "tickets.eyebrow": "门票",
  "tickets.standard": "Standard 门票",
  "tickets.group": "4人团体票",
  "tickets.vip": "VIP 卡座票",
  "tickets.nextRelease": "下一轮发售：",
  "tickets.finalRelease": "最后一轮在线售票",
  "tickets.soldOut": "售罄",
  "tickets.buy": "购买门票",
  "tickets.buyGroup": "购买团体票",
  "tickets.groupPerPerson": "4 × Standard门票 · 每人{price}",
  "tickets.limitedCapacity": "数量有限",
  "tickets.reserve": "预订卡座",
  "tickets.vipRequired": "需要 VIP 卡座票",
  "tickets.wantTable": "想预订带酒水服务的卡座？需要 VIP 卡座票。",
  "tickets.noRefund": "门票不可退款 · 仅当主办方取消活动时全额退款",
  "tickets.swipe": "滑动查看更多",
  "tickets.priceProgression": "每轮售完后价格将上调",
  "tickets.loading": "门票加载中…",
  "tickets.unavailable": "暂时无法加载门票",
  "perks.std1": "进入全部3个舞台",
  "perks.std2": "站立区和舞池",
  "perks.std3": "进入所有公共酒吧和天台",
  "perks.no1": "不可进入VIP卡座区",
  "perks.no2": "无预留卡座或保证座位",
  "perks.no3": "无酒水服务",
  "perks.vip1": "惊喜礼物 ❤️‍🔥🎈（价值200克朗）",
  "perks.vip2": "进入Seoul Floor（7楼）和Saigon Floor（5楼）的VIP区。",
  "tickets.gold": "VIP Gold Table",
  "tickets.goldBadge": "仅限3桌",
  "tickets.goldFee": "桌费 3999 Kč + 每位 899 Kč",
  "perks.gold1": "靠近舞台的桌位",
  "perks.gold2": "进入全部3个舞台",
  "perks.gold3": "进入Seoul Floor（7楼）和Saigon Floor（5楼）的VIP区",
  "perks.gold4": "优先入场、VIP卫生间和专属服务员",
  "perks.gold5": "每位宾客1份惊喜礼物",
  "perks.gold6": "酒水服务可单独订购",
  "tickets.buyGold": "购买 Gold Table",
  "checkout.guestsGold": "人数（4–14）",
  "checkout.guestsWord": "位宾客",
  "hero.upgrade": "升级至VIP",
  "upgrade.title": "升级至VIP",
  "upgrade.subtitle": "已有普通票？支付400 Kč升级为VIP桌票。",
  "upgrade.codeLabel": "您的票券代码",
  "upgrade.codePlaceholder": "ATF-XXXXXX",
  "upgrade.verify": "验证票券",
  "upgrade.found": "已找到票券",
  "upgrade.priceLine": "升级价格",
  "upgrade.sameQr": "您的二维码保持不变——付款后扫描即显示为VIP。",
  "upgrade.pay": "支付升级费用",
  "upgrade.processing": "正在创建支付…",
  "success.upgradeNote": "您的票已升级为VIP——请继续使用原二维码。",
  "perks.vip3": "可预订带酒水服务的VIP卡座",
  "perks.vip4": "预订卡座配有专属服务员",
  "perks.vip5": "进入7楼VIP露台",
  "perks.vip6": "优先入场",
  "perks.vip7": "VIP卫生间",

  "checkout.secure": "安全结账",
  "checkout.fullName": "姓名",
  "checkout.namePlaceholder": "您的姓名",
  "checkout.email": "电子邮箱",
  "checkout.phone": "电话号码",
  "checkout.quantity": "数量",
  "checkout.ticketOne": "张票",
  "checkout.ticketMany": "张票",
  "checkout.groupNote": "1组 = 4张票",
  "checkout.discountCode": "折扣码",
  "checkout.enterCode": "输入折扣码",
  "checkout.apply": "使用",
  "checkout.codeApplied": "折扣码 {code} 已生效：−{percent}%（原价 {price}）",
  "checkout.continueToPayment": "继续支付",
  "checkout.secureNote": "由Teya提供安全刷卡支付，就在本页面完成。付款确认后才会出票。",
  "checkout.termsNoteA": "继续即表示您同意我们的",
  "checkout.termsNoteB": "条款与条件",
  "checkout.termsNoteC": "。门票不可退款，可自由转让。",
  "checkout.creating": "正在创建订单…",
  "checkout.securePayment": "安全支付",
  "checkout.groupTickets": "1组（4张票）",
  "checkout.teyaNote": "支付由Teya处理。付款确认后，带二维码的门票会立即发送到您的邮箱。",
  "checkout.promoApplyFirst": "请先点击“使用”激活折扣码，然后再付款。",

  "success.confirming": "正在确认您的付款…",
  "success.confirmingText": "我们正在与支付网关核实您的付款。本页面会自动更新——无需刷新。",
  "success.slowNote": "比平时稍慢——您的付款仍在确认中。完成后门票会显示在这里，我们也会发送到您的邮箱。您可以保持本页面打开。",
  "success.confirmed": "付款已确认",
  "success.youreIn": "购票成功！",
  "success.orderLine": "订单 {order} · {tier} × {qty} · {amount} · 请截图保存门票，入场时出示二维码。",
  "success.loadingTickets": "正在加载门票…",
  "success.notCompleted": "支付未完成",
  "success.cancelled": "支付已取消。",
  "success.expired": "支付会话已过期。",
  "success.failed": "支付失败。",
  "success.noCharge": "未出票，您的账户未被扣款。",
  "success.backToTickets": "返回购票",
  "success.refunded": "订单已退款",
  "success.refundedText": "此订单已{how}退款。",
  "success.fully": "全额",
  "success.partially": "部分",
  "success.notFound": "找不到订单",
  "success.notFoundText": "我们找不到此订单。如果您刚刚付款，请稍等片刻再查看。",
  "success.backHome": "← 返回首页",

  "reserve.eyebrow": "VIP 卡座票",
  "reserve.titleA": "预订",
  "reserve.titleB": "卡座",
  "reserve.intro": "告诉我们您的需求——我们会回复您卡座选项和酒水服务详情。",
  "reserve.received": "已收到您的请求",
  "reserve.receivedText": "我们会尽快联系您安排VIP卡座。9月27日DUPLEX见。",
  "reserve.back": "← 返回购票",
  "reserve.fullName": "姓名",
  "reserve.phone": "电话号码",
  "reserve.email": "电子邮箱",
  "reserve.guests": "人数",
  "reserve.floor": "首选楼层",
  "reserve.message": "留言（可选）",
  "reserve.messagePlaceholder": "场合、预算、酒水偏好…",
  "reserve.send": "发送请求",
  "reserve.sending": "发送中…",

  "contact.eyebrow": "联系我们",
  "contact.title": "取得联系",
  "contact.email": "电子邮箱",
  "contact.instagram": "Instagram",
  "contact.venue": "场地",
  "contact.note": "关于VIP卡座、合作和媒体事宜，请发邮件给我们，我们会在48小时内回复。",

  "gallery.eyebrow": "相册",
  "gallery.titleA": "场地",
  "gallery.titleB": "地图",
  "gallery.rooms": "KPOP厅 • Mainstream厅 • Saigon厅",
};
